import React, { createContext, useContext } from 'react';

const ArticleViewContext = createContext(null);

export function ArticleViewProvider({ value, children }) {
    return <ArticleViewContext.Provider value={value}>{children}</ArticleViewContext.Provider>;
}

export function useArticleView() {
    const context = useContext(ArticleViewContext);
    if (!context) {
        throw new Error('useArticleView must be used within ArticleViewProvider');
    }
    return context;
}
